module.exports = __webpack_public_path__ + "img/UTCAMP-2.ce647bed.jpg";